// extracted by mini-css-extract-plugin
module.exports = {"icon":"idt-clouduploadanimation_icon__1xwek","arrow":"idt-clouduploadanimation_arrow__nu-mb"};